export default "__VITE_ASSET__CHOnCzrU__"